'use client';
import { jsx } from 'react/jsx-runtime';
import { Sticky } from 'react-unstuck';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { media } from '../../mixins/media.js';
import '../../mixins/keyboardFocus.js';
import '../../mixins/markStyle.js';
import '../../mixins/scrollbarStyle.js';
import '../../mixins/textStyle.js';
import { ContentWrapper } from '../ContentWrapper/ContentWrapper.js';
import { stickToBottom } from './behaviors/stickToBottom.js';

const StyledFooter = styled(ContentWrapper).withConfig({
  componentId: "sc-yq4qh0-0"
})(["background:", ";border-top:1px solid ", ";padding:", " 0;margin:0 auto;padding-left:", ";padding-right:", ";", ""], ({
  theme
}) => theme.components.fullscreenLayout.backgroundColor, ({
  theme
}) => theme.components.fullscreenLayout.footerBorderColor, ({
  theme
}) => theme.components.fullscreenLayout.footerPaddingVertical, ({
  theme
}) => theme.components.fullscreenLayout.footerPaddingHorizontal, ({
  theme
}) => theme.components.fullscreenLayout.footerPaddingHorizontal, media.greaterThan('m')`
    padding-left: 0;
    padding-right: 0;
  `);
const FullscreenLayoutFooter = /*#__PURE__*/withTitan(({
  children,
  testId = 'fullscreenLayoutFooter'
}) => {
  return jsx(Sticky, {
    behavior: stickToBottom,
    children: jsx(StyledFooter, {
      id: "modal-footer",
      maxWidth: 600,
      testId: testId,
      children: children
    })
  });
}, {
  name: 'FullscreenLayoutFooter'
});

export { FullscreenLayoutFooter };
//# sourceMappingURL=FullscreenLayoutFooter.js.map
